module.exports = __webpack_public_path__ + "img/gc_country_flag_vn.cbd29965.svg";